import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { ReactComponent as DeleteIcon } from "./../../../assets/Icons/Delete.svg";
import { ReactComponent as EditIcon } from "./../../../assets/Icons/edit.svg";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { ChangeUserRolePagePath } from "constants/pages";
import { DeleteUserFromFund } from "./delete-user-from-fund";
import { FundUsersRoles } from "types/FundUsersRoles";
interface RolesSettingsMenuProps {
  user: FundUsersRoles;
  refetch: () => void;
  nonSuperAdminAdminCount: number;
  superAdminEmail?: string;
}
export const RolesSettingsMenu: React.FC<RolesSettingsMenuProps> = ({
  user,
  refetch,
  nonSuperAdminAdminCount,
  superAdminEmail,
}) => {
  const navigate = useNavigate();
  const [openCancelDialog, setOpenCancelDialog] = useState<boolean>(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDisabledClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    event.preventDefault();
  };
  const openEditPage = () => {
    const url = ChangeUserRolePagePath.replace(":id", user.id.toString());
    navigate(url);
  };

  // Super admin must never remove themselves. Non-super-admin admin can remove themselves only if at least one other non-super-admin admin remains.
  const isSuperAdminRow = Boolean(superAdminEmail && user.email === superAdminEmail);
  const shouldShowMenu =
    !isSuperAdminRow &&
    (user.role !== "ADMIN" || nonSuperAdminAdminCount >= 2);

  return (
    <>
      <DeleteUserFromFund
        open={openCancelDialog}
        user={user}
        onClose={() => {
          setOpenCancelDialog(false);
          refetch();
        }}
      />
      <IconButton
        onClick={shouldShowMenu ? handleClick : handleDisabledClick}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <MoreVertIcon sx={{
          color: !shouldShowMenu ? 'neutral.light' : 'neutral.disabled',
        }} />
      </IconButton>
      {anchorEl && shouldShowMenu && (
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          sx={{
            "& .MuiMenu-paper": { px: 1 },
          }}
          MenuListProps={{
            onClick: (e) => e.stopPropagation(),
            onMouseDown: (e) => e.stopPropagation(),
          }}
        >
          <MenuItem className="contribution-dropdown" onClick={openEditPage}>
            <EditIcon /> Change role
          </MenuItem>
          <MenuItem
            className="contribution-dropdown"
            onClick={() => {
              setOpenCancelDialog(true);
              handleClose();
            }}
          >
            <DeleteIcon /> Delete
          </MenuItem>
        </Menu>
      )}
    </>
  );
};
